import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { LessonLessonsBridge } from './bridges/lesson_lessons.bridge';
import { LESSONS_FEATURE_KEY } from './keys';
import { lessonsReducer } from './reducers/lessons.reducer';
import { LessonsEffects } from './effects/lessons.effects';

export function provideLessonsStore(): EnvironmentProviders[] {
    return [provideState(LESSONS_FEATURE_KEY, lessonsReducer), provideEffects(LessonsEffects, LessonLessonsBridge)];
}
